import React, { Fragment} from "react";
import HTMLFlipBook from "react-pageflip";
import ProductosVariables from "../cart/ProductosVariables";
import CarritoEnProductos from "../cart/CarritoEnProductos";
import MostrarVideos from "../MostrarVideos"

import "./flipbook.css";
import { Icon } from 'semantic-ui-react';

const PageCover = React.forwardRef((props, ref) => {
  let contenido = props.contenido
  return (
    <div className={"page page-cover " + contenido} ref={ref} data-density="hard">
      <div className="page-content">
        
      </div>
    </div>
  );
});

const Page = React.forwardRef((props, ref) => {
  let number = props.number
  return <div ref={ref} className={"Page"+number+" page"}>
       <div className="page-content">{props.children}</div> 
  </div>;
});




export default class MyBookCel extends React.Component {
  
  constructor(props) {
    super(props);

    this.state = {
      page: 0,
      totalPage: 0,
      contro: true
    };
  }

  bloquearClick = () => {
    this.flipBook.getPageFlip();
  };
  nextButtonClick = () => {
    this.flipBook.getPageFlip().flipNext();
  };

  prevButtonClick = () => {
    this.flipBook.getPageFlip().flipPrev();
  };

  onPage = (e) => {
    this.setState({
      page: e.data,
    });
  };
  
  cambiar = () =>{
  
    this.state.contro = false


  }

  componentDidMount() {
    this.setState({
      totalPage: this.flipBook.getPageFlip().getPageCount(),
    });
  }

  render() {

    return (
      <Fragment>
        <div className="row">
        <div className="col-6">
          <div className="celularBook">
          <HTMLFlipBook
            width={535}
            height={740}
            size="stretch"
            minWidth={370}
            maxWidth={535}
            minHeight={518}
            maxHeight={740}
            maxShadowOpacity={0.5}
            showCover={true}
            mobileScrollSupport={true}
            onFlip={this.onPage}
            clickEventForward={true}
            useMouseEvents={false}
            usePortrait={true}
            onChangeOrientation={this.onChangeOrientation}
            onChangeState={this.onChangeState}
            ref={(el) => (this.flipBook = el)}
          >
            
              <PageCover contenido={"inicio"}></PageCover>           

              <Page number={1}></Page>

              <Page number={2}></Page>

              <Page number={3}>
                <CarritoEnProductos idProducto={'57455'} left={"60px"} top={"305px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={4}>
                <CarritoEnProductos idProducto={'57463'} left={"210px"} top={"43px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'57460'} left={"100px"} top={"270px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={5}>
                <CarritoEnProductos idProducto={'57718'} left={"300px"} top={"195px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'57710'} left={"20px"} top={"290px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'57715'} left={"310px"} top={"400px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={6}>
                <CarritoEnProductos idProducto={''} left={"210px"} top={"45px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'57706'} left={"265px"} top={"90px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'57703'} left={"70px"} top={"260px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'57699'} left={"200px"} top={"290px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'57863'} left={"245px"} top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={7}></Page>

              <Page number={8}></Page>

              <Page number={9}>
                <CarritoEnProductos idProducto={'57443'} left={"200px"}  top={"50px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={10}>
                <CarritoEnProductos idProducto={'57446'} left={"205px"}  top={"200px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={11}>
                <CarritoEnProductos idProducto={'57449'} left={"220px"}  top={"50px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={12}></Page>

              <Page number={13}>
                <ProductosVariables idProducto={'39039'} left={"270px"}  top={"120px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />

                <ProductosVariables idProducto={'39063'} left={"10px"}  top={"355px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'39096'} left={"90px"}  top={"355px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'39147'} left={"175px"}  top={"355px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18536'} left={"255px"}  top={"355px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={14}></Page>

              <Page number={15}></Page>

              <Page number={16}>
                <CarritoEnProductos idProducto={'18692'} left={"10px"}  top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18600'} left={"70px"}  top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18620'} left={"130px"}  top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'19696'} left={"205px"}  top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18687'} left={"280px"}  top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={17}>
                <CarritoEnProductos idProducto={'18654'} left={"15px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'47302'} left={"70px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18716'} left={"130px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18651'} left={"195px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18715'} left={"260px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={18}>
                <CarritoEnProductos idProducto={'18749'} left={"50px"}  top={"370px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />                
                <CarritoEnProductos idProducto={'29146'} left={"195px"}  top={"370px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={19}>
                <CarritoEnProductos idProducto={'18723'} left={"35px"}  top={"385px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18569'} left={"115px"}  top={"385px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18701'} left={"210px"}  top={"385px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'32087'} left={"285px"}  top={"385px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={20}></Page>
    
              <Page number={21}>                
                <CarritoEnProductos idProducto={'52250'} left={"150px"}  top={"300px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'52285'} left={"260px"}  top={"300px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'52253'} left={"215px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />              
              </Page>

              <Page number={22}>
                <CarritoEnProductos idProducto={'18600'} left={"180px"} top={"270px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'29079'} left={"180px"} top={"340px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'27323'} left={"180px"} top={"400px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={23}>
                <CarritoEnProductos idProducto={''} left={"20px"}  top={"0px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'25996'} left={"240px"}  top={"110px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'25994'} left={"240px"}  top={"170px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'25990'} left={"70px"}  top={"340px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'39124'} left={"70px"}  top={"395px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={''} left={"230px"}  top={"400px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={24}>
                <CarritoEnProductos idProducto={'18659'} left={"65px"}  top={"90px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18662'} left={"35px"}  top={"320px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={25}>
                <CarritoEnProductos idProducto={'18678'} left={"255px"} top={"15px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'25526'} left={"40px"} top={"280px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'20034'} left={"225px"} top={"360px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />                
              </Page>

              <Page number={26}>
                <CarritoEnProductos idProducto={'22552'} left={"240px"} top={"25px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={27}></Page>

              <Page number={28}>
                <CarritoEnProductos idProducto={'19694'} left={"85px"}  top={"50px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18733'} left={"25px"}  top={"300px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'19695'} left={"115px"}  top={"360px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18679'} left={"195px"}  top={"300px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18705'} left={"280px"}  top={"300px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={29}>
                <CarritoEnProductos idProducto={'18686'}   left={"260px"} top={"0px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'28044'}   left={"55px"} top={"360px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={30}>
                <CarritoEnProductos idProducto={'18704'}   left={"195px"} top={"0px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'47291'}   left={"225px"} top={"310px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={31}></Page>

              <Page number={32}>
                <CarritoEnProductos idProducto={'54982'} left={"160px"} top={"10px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={33}></Page>

              <Page number={34}></Page>

              <Page number={35}>
                <CarritoEnProductos idProducto={'18661'} left={"20px"} top={"380px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18644'} left={"185px"} top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={36}>
                <ProductosVariables idProducto={'18549'}   left={"120px"} top={"0px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'18669'}   left={"40px"} top={"330px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={37}> 
                <ProductosVariables idProducto={'18747'} left={"135px"} top={"120px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'19703'} left={"255px"} top={"105px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'18713'} left={"85px"} top={"340px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={38}>
                {/* <ProductosVariables idProducto={'69038'} left={"20px"} top={"270px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} /> */}
              </Page>
 
              <Page number={39}></Page>

              <Page number={40}>
                <CarritoEnProductos idProducto={'18693'} left={"55px"} top={"75px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18666'} left={"270px"} top={"70px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'39045'} left={"150px"} top={"330px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={41}> 
                <CarritoEnProductos idProducto={'21567'} left={"255px"} top={"35px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'21577'} left={"230px"} top={"140px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'18664'} left={"240px"} top={"350px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={42}>
                <CarritoEnProductos idProducto={'18650'} left={"280px"} top={"0px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={43}>
                <CarritoEnProductos idProducto={'18643'} left={"270px"} top={"95px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18695'} left={"290px"} top={"270px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'19896'} left={"70px"} top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'21573'} left={"170px"} top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18652'} left={"290px"} top={"375px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={44}>
                <CarritoEnProductos idProducto={'18676'} left={"60px"} top={"335px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'35382'} left={"260px"} top={"20px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={45}>
                <CarritoEnProductos idProducto={'18631'} left={"0px"} top={"135px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18629'} left={"0px"} top={"210px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                
                <CarritoEnProductos idProducto={'18626'} left={"90px"} top={"45px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18630'} left={"115px"} top={"245px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18633'} left={"75px"} top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />

                <CarritoEnProductos idProducto={'18632'} left={"220px"} top={"0px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'19894'} left={"205px"} top={"215px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />

                <CarritoEnProductos idProducto={'18627'} left={"315px"} top={"30px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'36993'} left={"290px"} top={"335px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={46}>
                <CarritoEnProductos idProducto={'18575'} left={"275px"} top={"150px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={47}></Page>

              <Page number={48}>
                <ProductosVariables idProducto={'18610'} left={"85px"} top={"135px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={49}>                
                <CarritoEnProductos idProducto={'18710'} left={"250px"} top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={50}>
                <ProductosVariables idProducto={'18576'} left={"15px"}   top={"379px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={51}>                
                <CarritoEnProductos idProducto={'18674'} left={"195px"} top={"45px"} width={"30px"} height={"30px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'19692'} left={"195px"} top={"70px"} width={"30px"} height={"30px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18741'} left={"195px"} top={"95px"} width={"30px"} height={"30px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18685'} left={"195px"} top={"125px"} width={"30px"} height={"30px"} addProductCart={this.props.addProductCart} />                
               
                <CarritoEnProductos idProducto={'18740'} left={"10px"}  top={"315px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18660'} left={"140px"}  top={"345px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18719'} left={"295px"}  top={"290px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={52}>
                <ProductosVariables idProducto={'18634'} left={"125px"}   top={"300px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'18638'} left={"255px"}   top={"310px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={53}>
                <ProductosVariables idProducto={'18752'} left={"265px"}  top={"40px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'18734'} left={"280px"}  top={"350px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={54}>
                <CarritoEnProductos idProducto={'18567'} left={"20px"} top={"305px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'18720'} left={"5px"} top={"395px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={55}>
                {/* <ProductosVariables idProducto={'57664'}  left={"285px"} top={"20px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />                 */}
              </Page>

              <Page number={56}></Page>

              <Page number={57}></Page>

              <Page number={58}>
                <ProductosVariables idProducto={'44496'} left={"5px"} top={"430px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={59}>
                <CarritoEnProductos idProducto={'52326'} left={"40px"} top={"80px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'52254'} left={"45px"} top={"395px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={60}>
                <CarritoEnProductos idProducto={'19693'} left={"255px"}  top={"20px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={61}>
                <CarritoEnProductos idProducto={'18541'} left={"25px"}  top={"225px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18542'} left={"135px"}  top={"225px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18540'} left={"235px"}  top={"225px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18758'} left={"10px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18658'} left={"145px"}  top={"390px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={62}>
                <CarritoEnProductos idProducto={'19702'} left={"250px"}  top={"75px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'34489'} left={"240px"}  top={"385px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>
{/* VOY POR AQUI */}
              <Page number={63}>
                <ProductosVariables idProducto={'47952'} left={"55px"}  top={"70px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <ProductosVariables idProducto={'47928'} left={"50px"}  top={"320px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={64}>               
                {/* <CarritoEnProductos idProducto={''} left={"120px"}  top={"160px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} /> */}
              </Page>

              <Page number={65}></Page>

              <Page number={66}>
                <CarritoEnProductos idProducto={'19691'} left={"80px"}  top={"360px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'27878'} left={"200px"}  top={"410px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={67}>
                <CarritoEnProductos idProducto={'18601'} left={"130px"}  top={"80px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
                <CarritoEnProductos idProducto={'18675'} left={"135px"}  top={"350px"} width={"50px"} height={"50px"} addProductCart={this.props.addProductCart} />
              </Page>

              <Page number={68}></Page>

              <Page number={69}></Page>

            </HTMLFlipBook>
            </div>
            </div>
         
        </div>
        <br></br>
        <br></br>
        <br></br>
        <div id="slide">
          <div className="flechas" id="retroceder"  onClick={this.prevButtonClick}> <Icon name='angle left'  size='huge' /></div>
          <div className="flechas" id="avanzar"   onClick={this.nextButtonClick}><Icon name='angle right'  size='huge' />  </div>
        </div>       
      </Fragment>
    );
  }
}